import { Search, Toasts } from 'components'
import { toggleCookieHubWheel } from 'utility/cookie-hub-wheel'
import { WarningIcon } from '../icons'
import { ISideCartResponse } from '../interfaces/side-cart-interfaces'
import { Cart } from './cart'
import { CartRecycle } from './cart-recycle'

const el = {
  trigger: document.querySelector<HTMLButtonElement>('#cart-button'),
  triggerWrapper: document.querySelector<HTMLLIElement>('#cart-button-wrapper'),
  sideCart: document.querySelector<HTMLDivElement>('.side-cart'),
  sideExtension: document.querySelector<HTMLDivElement>('.side-extension'),
  overlay: document.querySelector<HTMLDivElement>('.overlay'),
  mobileMenu: document.querySelector<HTMLDivElement>('.mobile-menu'),
  mobileBurger: document.querySelector<HTMLButtonElement>('.header__burger'),
  getOrderForm: document.querySelector<HTMLFormElement>('.getorder__form'),
  cartRecycle: document.querySelector<HTMLDivElement>('.cart-recycle'),
}

export const SideCart = {
  init: () => {
    if (!el.sideCart || !el.trigger || !el.sideExtension) return
    el.trigger.addEventListener('click', SideCart.toggleMenu)
    if (el.overlay) el.overlay.addEventListener('click', SideCart.closeMenu)
  },

  openMenu: async () => {
    // TODO: TEMP FIX - remove when cart recycle is enabled again
    el.sideExtension.classList.remove('side-extension--hidden')

    SideCart.toggleButtonState({ loading: true })
    const success = await SideCart.fetchSideCart()
    SideCart.toggleButtonState({ loading: false })

    if (!success) {
      SideCart.closeMenu()
      return
    }

    Search.onClose()

    el.sideCart.classList.add('side-cart--open')
    el.sideExtension.classList.add('side-extension--open')
    document.body.classList.add('h-disable-scroll')
    if (el.overlay) el.overlay.classList.add('overlay--visible')
    if (el.mobileMenu) el.mobileMenu.classList.remove('mobile-menu--open')
    if (el.mobileBurger) el.mobileBurger.classList.remove('burger--open')
    if (el.cartRecycle) el.cartRecycle.classList.remove('cart-recycle--open')
    toggleCookieHubWheel({ hide: true })
  },

  closeMenu: (search?) => {
    el.sideCart.classList.remove('side-cart--open')
    el.sideExtension.classList.remove('side-extension--open')

    document.body.classList.remove('h-disable-scroll')
    if (el.overlay && !search) el.overlay.classList.remove('overlay--visible')
    toggleCookieHubWheel({ hide: false })
  },

  toggleMenu: () => {
    if (el.sideCart.classList.contains('side-cart--open')) {
      SideCart.closeMenu()
      return
    }
    SideCart.openMenu()
  },

  fetchSideCart: async () => {
    try {
      if (!el.getOrderForm) throw Error('')

      const formData = new FormData(el.getOrderForm)
      const action = el.getOrderForm.getAttribute('action')
      const formMethod = el.getOrderForm.getAttribute('method')

      const response = await fetch(action, { method: formMethod, body: formData })
      const data: ISideCartResponse = await response.json()
      if (!data.success) throw Error('')

      SideCart.updateSideCart(data)
      return true
    } catch (_) {
      Toasts.addToast({
        title: 'Villa kom upp!',
        text: 'Ekki tókst að sækja körfu.',
        icon: WarningIcon(),
      })
      return false
    }
  },

  updateSideCart: (data: ISideCartResponse) => {
    el.sideCart.innerHTML = data.sideCartHtml


    // TODO: TEMP FIX - revert when cart-recycle has been enabled again
    if (data.sideExtensionHtml.includes('side-extension__products')) {
      el.sideExtension.innerHTML = data.sideExtensionHtml
      el.sideExtension.classList.remove('side-extension--hidden')
    } else {
      el.sideExtension.classList.add('side-extension--hidden')
    }


    Cart.activeCartItems({ sideCartOnly: true })

    const cartRecycleButtons = document.querySelectorAll<HTMLButtonElement>(
      '.side-extension .cart-recycle-button, .side-cart .cart-recycle-button'
    )
    cartRecycleButtons.forEach((target) =>
      target.addEventListener('click', CartRecycle.openMenu)
    )

    const addToCartForms = document.querySelectorAll<HTMLFormElement>(
      '.side-extension .add-to-cart-form'
    )
    addToCartForms.forEach((target) => target.addEventListener('submit', Cart.addToCart))

    const closeButton = document.querySelector<HTMLButtonElement>('.side-cart__close')
    if (closeButton) closeButton.addEventListener('click', SideCart.closeMenu)

    if (!el.triggerWrapper) return

    // if cart is empty we close the side-cart and hide the cart button
    if (!data.cart.Order.OrderLines.length) {
      SideCart.closeMenu()
      el.triggerWrapper.classList.add('header__item--hide')
      return
    }

    el.triggerWrapper.classList.remove('header__item--hide')

    // update cart count
    const cartCount = el.triggerWrapper.querySelector<HTMLSpanElement>('.cart-count')
    if (!cartCount) return
    cartCount.innerText = data.cart.TotalQuantity.toString()
  },

  toggleButtonState: ({ loading = false }) => {
    const cartCount = el.triggerWrapper.querySelector<HTMLSpanElement>('.cart-count')
    if (loading) {
      el.trigger.classList.add('button--loading')
      if (cartCount) cartCount.style.display = 'none'
      return
    }

    el.trigger.classList.remove('button--loading')
    if (cartCount) cartCount.style.display = ''
  },
}
